import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import DetailForm from './components/DetailForm.vue'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
import { newClientEvaluationDetail } from '@/api/overseasSales/newClientEvaluation'

const __default__ = { name: 'DcCosOFbuNewClientEvaluationEdit' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()

const initForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business: {
    demandInfo: { warehouses: [{}] },
    saleInfo: [{}],
    quotationInfo: { details: [{}] },
    contractInfo: { fixedCredit: {}, registrationFee: {}, monthlyMaintenanceFee: {} }
  },
  visitAddress: [{}]
})

const dataForm = reactive<FbuSalesClueEditParams.RootObject>(cloneDeep(initForm))
const clueTypeDisabled = ref(false)

onBeforeMount(() => {
  let fetchId = -1
  /// 这里判断两次一种是草稿id一种是流程id
  if (route.query.newClientId) {
    fetchId = route.query.newClientId as unknown as number
  } else if (route.query.draftId) {
    fetchId = route.query.draftId as unknown as number
  }
  newClientEvaluationDetail({ id: fetchId }).then((res) => {
    if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
      res.data.business.businessTypeSelect = res.data.business.businessType[0]
    }
    Object.assign(initForm, res.data)
    Object.assign(dataForm, res.data)
  })
})

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(DetailForm, {
            ref: "detailFormRef",
            type: "edit",
            isEdit: "",
            value: dataForm,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm) = $event)),
            clueTypeDisabled: clueTypeDisabled.value,
            resetValue: initForm
          }, null, 8, ["value", "clueTypeDisabled", "resetValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})